import { render, staticRenderFns } from "./AudioIcon.vue?vue&type=template&id=4db89a0e&scoped=true&"
import script from "./AudioIcon.vue?vue&type=script&lang=js&"
export * from "./AudioIcon.vue?vue&type=script&lang=js&"
import style0 from "./AudioIcon.vue?vue&type=style&index=0&id=4db89a0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db89a0e",
  null
  
)

export default component.exports